export const CHECKBOX = {
  "Checkbox.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Checkbox.Color": {
    ref: "Input.Color"
  },
  "Checkbox.Line.Height": {
    ref: "Input.Line.Height"
  },
  "Checkbox.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Checkbox.Letter.Spacing": {
    ref: "Input.Letter.Spacing"
  },
  "Checkbox.Disabled.Text.Color": {
    ref: "Color.Text.Gray.100"
  },
  "Checkbox.Spacing": {
    ref: "Space.8"
  }
};
